/**
 * Supported languages for system notices and other multilingual content
 */

export interface Language {
  /** IETF language tag (e.g., "en", "fr", "de") */
  code: string;
  /** Display name for the language */
  name: string;
  /** Native name of the language */
  nativeName: string;
}

/**
 * List of supported languages
 */
export const SUPPORTED_LANGUAGES: Language[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
];

/**
 * Get language display name by code
 */
export function getLanguageName(code: string): string {
  const language = SUPPORTED_LANGUAGES.find((lang) => lang.code === code);
  return language ? language.name : code;
}

/**
 * Get language native name by code
 */
export function getLanguageNativeName(code: string): string {
  const language = SUPPORTED_LANGUAGES.find((lang) => lang.code === code);
  return language ? language.nativeName : code;
}

/**
 * Check if a language code is supported
 */
export function isLanguageSupported(code: string): boolean {
  return SUPPORTED_LANGUAGES.some((lang) => lang.code === code);
}

/**
 * Get all supported language codes
 */
export function getSupportedLanguageCodes(): string[] {
  return SUPPORTED_LANGUAGES.map((lang) => lang.code);
}

/**
 * Default language code
 */
export const DEFAULT_LANGUAGE = 'en';
